module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Da-Ea.8d679fdf.png";